import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { getCurrentView } from '../store/selectors/ui';
import { hideOverlayFilters, showOverlayFilters } from '../store/actions/ui';

import { isMobile } from 'helpers/mobile_helpers';

import ColumnSelector from '../columns/selector';
import ColumnSelectorButton from 'bundles/research/index/components/column_selector_button';
import SidebarSearch from 'components/search_sidebar/sidebar_search';
import CompsSavedSearchTopbar from 'bundles/comps/index/searches/comps_saved_search_topbar';
import ViewToggle from 'bundles/comps/index/comps_view_toggle';

export class CompsFilterRow extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    currentView: PropTypes.string.isRequired,
    edgeCrm: PropTypes.bool,
    hideOverlayFilters: PropTypes.func.isRequired,
    hidePageData: PropTypes.bool,
    pageData: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      itemSingularLabel: PropTypes.string.isRequired,
      pageSize: PropTypes.number.isRequired,
      totalCount: PropTypes.number.isRequired
    }),
    searchFormGroupChildren: PropTypes.any,
    searchPlaceholder: PropTypes.string,
    searchText: PropTypes.string,
    showColumnFilters: PropTypes.bool,
    showOverlayFilters: PropTypes.func.isRequired,
    onSearchChange: PropTypes.func
  }

  static defaultProps = {
    searchPlaceholder: 'Search'
  }

  render() {
    return (
      <div className="d-flex align-items-center gap-2 flex-fill">
        <div className="d-flex gap-2 align-items-center flex-fill">
          {this.renderSearchBar()}
          <div className="d-none d-md-inline-flex">{this.props.children}</div>
        </div>

        <div className="d-flex gap-2">
          {this.props.edgeCrm && this.props.currentView !== 'map' &&
            <ColumnSelectorButton
              hide={this.props.showColumnFilters}
              onClose={this.props.hideOverlayFilters}
              onOpen={this.props.showOverlayFilters}
            >
              <ColumnSelector/>
            </ColumnSelectorButton>
          }

          {this.props.edgeCrm && <ViewToggle/>}
        </div>

        {!this.props.edgeCrm &&
          <div className="d-inline-block">
            <CompsSavedSearchTopbar />
          </div>
        }
      </div>
    );
  }

  renderSearchBar() {
    const { searchPlaceholder, searchText, onSearchChange } = this.props;

    if (!onSearchChange) return null;

    return (
      <SidebarSearch
        additionalClasses="flex-shrink-0"
        inputProps={{
          name: 'search_text',
          className: 'flex-fill',
        }}
        placeholder={searchPlaceholder}
        style={{ minWidth: isMobile() ? '100%' : 332 }}
        value={searchText}
        onChange={onSearchChange}
      >
        {this.props.searchFormGroupChildren}
      </SidebarSearch>
    );
  }
}

const mapStateToProps = state => ({
  currentView: getCurrentView(state),
  showColumnFilters: state.ui.showColumnFilters,
});

const mapDispatchToProps = {
  hideOverlayFilters,
  showOverlayFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsFilterRow);
